import * as React from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useRouter } from 'solito/router'
import { createLogoutFn } from '../methods/logout'
import { useClerk } from '~/universal/clerk'

export function useLogout() {
  const router = useRouter()
  const clerk = useClerk()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationKey: ['auth', 'logout'],
    mutationFn: createLogoutFn(queryClient, clerk),
  })

  const action = React.useCallback(
    () =>
      mutation.mutate(undefined, {
        onSuccess() {
          router.push('/home')
        },
      }),
    [mutation, router]
  )

  return {
    // isLoaded: clerk.loaded,
    // isSignedIn: clerk.session?.status === 'active',
    action,
    mutation,
  }
}
